import React from "react";
import { FiAlertTriangle } from "react-icons/fi";

const DeleteGroupTrainingModal = ({ isOpen, onClose, onConfirm, itemName, isLoading }) => {
    if (!isOpen) return null;

    return (
        <div className="modern-modal-overlay">
            <div className="modern-modal confirmation-modal">
                <div className="modern-modal-header">
                    <h2 className="modern-modal-title">Potwierdź usunięcie</h2>
                    <button
                        className="modern-close-btn"
                        onClick={onClose}
                    >
                        &times;
                    </button>
                </div>

                <div className="modern-modal-content">
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
                        <FiAlertTriangle size={24} color="#ef4444" style={{ marginRight: "0.75rem" }} />
                        <strong>Czy na pewno chcesz usunąć {itemName}?</strong>
                    </div>
                    <p className="confirmation-message">
                        Ta operacja jest nieodwracalna i spowoduje usunięcie wszystkich powiązanych danych.
                    </p>
                    <p className="warning-message">
                        Wszystkie zaplanowane treningi dla tej grupy również zostaną usunięte.
                    </p>
                </div>

                <div className="modern-modal-footer">
                    <button
                        className="modern-cancel-button"
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        Anuluj
                    </button>
                    <button
                        className="modern-delete-btn"
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? "Usuwanie..." : "Usuń"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteGroupTrainingModal;